/* eslint-disable react/require-default-props */
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

import { MdClose } from 'react-icons/md';
import classNames from '../helpers/classNames';

function BaseModal({
  isOpen,
  onClose,
  children,
  width = 'w-11/12',
  padding = true,
  enableCloseButton = true,
}: {
  isOpen: boolean;
  onClose: (open: boolean) => void;
  children: React.ReactNode;
  padding?: boolean;
  width?: string;
  enableCloseButton?: boolean;
}) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  `relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all`,
                  width,
                  padding && 'p-4',
                )}
              >
                {enableCloseButton && (
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      className="rounded-md bg-white p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 active:bg-gray-200"
                      onClick={() => onClose(false)}
                    >
                      <MdClose className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default BaseModal;
